import React from "react"

const Accessories = props => (
  <div className="PDP-Accessories">
    <div>
      <h5 className="PDP-Title-Bold">Add an essential accessory</h5>
      <span>{props.note}</span>
    </div>
    {props.accessory}
  </div>
)

export default Accessories
